"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleWrapper = exports.StyleImg = exports.StyleIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyleWrapper = exports.StyleWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleWrapper",
  componentId: "sc-2qjjtv-0"
})(["position:static;"]);
const StyleImg = exports.StyleImg = _styledComponents.default.img.withConfig({
  displayName: "StyleImg",
  componentId: "sc-2qjjtv-1"
})(["width:24px;height:24px;transform:translate(4px,4px);opacity:0.9;transition:opacity 0.3s;pointer-events:none;&:hover{opacity:1;}"]);
const StyleIcon = exports.StyleIcon = _styledComponents.default.div.withConfig({
  displayName: "StyleIcon",
  componentId: "sc-2qjjtv-2"
})(["position:relative;cursor:pointer;"]);